import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface FmDeviceDialogProps {
  open: boolean;
  picturePath: string | null;
  handleClose: () => void;
}

/**
 * dialog that shows the enlarged image of item
 */
export function EnlargedImageDialog({
  open,
  picturePath,
  handleClose
}: Readonly<FmDeviceDialogProps>) {
  const { t } = useTranslation();
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!picturePath) return;

    if (open) {
      setImageLoaded(false);

      const img = new Image();
      img.src = picturePath;

      img.onload = () => {
        setImageLoaded(true);
      };

      img.onerror = () => {
        // Handle error if needed
        setImageLoaded(true); // or false to block dialog
      };
    } else {
      setImageLoaded(false); // Reset when dialog is closed
    }
  }, [open, picturePath]);

  if (!picturePath || !imageLoaded) return <></>;

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      aria-labelledby="enlarge-image-dialog-label"
      aria-describedby="enlarge-image-dialog-describe"
      maxWidth="lg"
      fullWidth={true} // fullScreen={isMobile}
      slots={{ transition: Zoom }}
      slotProps={{ transition: { timeout: { enter: 500, exit: 500 } } }} // slower transition
    >
      <DialogTitle id="enlarge-image-dialog-slide-title">{t("Show Image")}</DialogTitle>
      <DialogContent>
        <img
          src={picturePath}
          alt="enlarged-image"
          style={{ width: "100%", height: "75vh", objectFit: "contain" }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color={"secondary"} data-testid="close-enlarged-image-dialog">
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
